/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import { getSqlDatabaseImageSrc, getSqlDatabaseName, SqlImportDatabase } from 'cio/utils/sql-import';
import RouterService from '@ember/routing/router-service';
import { action } from '@ember/object';
import AnalyticsService from 'cio/services/analytics';

type DatabaseDetails = {
  id: SqlImportDatabase;
  name: string;
  imageSrc: string;
};

export default class SetupGuideSourcesSqlImport extends Component {
  @service store!: DS.Store;
  @service router!: RouterService;
  @service analytics!: AnalyticsService;

  readonly SqlImportDatabase = SqlImportDatabase;

  @tracked selectedDatabase?: DatabaseDetails;

  get databaseTypes(): DatabaseDetails[] {
    return Object.values(SqlImportDatabase).map((db: SqlImportDatabase) => {
      return {
        id: db,
        name: getSqlDatabaseName(db),
        imageSrc: getSqlDatabaseImageSrc(db),
      };
    });
  }

  @action
  setUpSync() {
    if (this.selectedDatabase) {
      this.analytics.track('integration', 'clicked', {
        name: this.selectedDatabase.id,
        from: 'Onboarding Guide',
        category: 'Databases',
        type: 'Native',
      });
      this.router.transitionTo('sql-imports.new', this.selectedDatabase.id);
    }
  }
}
